/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomSchema,
    InternalApiCustomSchemaFromJSON,
    InternalApiCustomSchemaToJSON,
    InternalApiEntitySchema,
    InternalApiEntitySchemaFromJSON,
    InternalApiEntitySchemaToJSON,
    InternalApiEntitySchemaFieldOrder,
    InternalApiEntitySchemaFieldOrderFromJSON,
    InternalApiEntitySchemaFieldOrderToJSON,
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
} from '../models';

export interface FindEntitySchemaRequest {
    entityType: InternalApiEntityType;
}

export interface SortEntitySchemaRequest {
    internalApiEntitySchemaFieldOrder: InternalApiEntitySchemaFieldOrder;
}

export interface UpdateEntitySchemaRequest {
    internalApiEntitySchema: InternalApiEntitySchema;
}

/**
 * 
 */
export class SchemaApi extends runtime.BaseAPI {

    /**
     * Fetches custom person schema for organisation
     */
    async findCustomPersonSchemaRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomSchema>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/schemas/person/custom-fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomSchemaFromJSON(jsonValue));
    }

    /**
     * Fetches custom person schema for organisation
     */
    async findCustomPersonSchema(initOverrides?: RequestInit): Promise<InternalApiCustomSchema> {
        const response = await this.findCustomPersonSchemaRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches schema
     */
    async findEntitySchemaRaw(requestParameters: FindEntitySchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntitySchema>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findEntitySchema.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/schemas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntitySchemaFromJSON(jsonValue));
    }

    /**
     * Fetches schema
     */
    async findEntitySchema(requestParameters: FindEntitySchemaRequest, initOverrides?: RequestInit): Promise<InternalApiEntitySchema> {
        const response = await this.findEntitySchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates entity schema sort order
     */
    async sortEntitySchemaRaw(requestParameters: SortEntitySchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntitySchema>> {
        if (requestParameters.internalApiEntitySchemaFieldOrder === null || requestParameters.internalApiEntitySchemaFieldOrder === undefined) {
            throw new runtime.RequiredError('internalApiEntitySchemaFieldOrder','Required parameter requestParameters.internalApiEntitySchemaFieldOrder was null or undefined when calling sortEntitySchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/schemas/sort-order`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiEntitySchemaFieldOrderToJSON(requestParameters.internalApiEntitySchemaFieldOrder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntitySchemaFromJSON(jsonValue));
    }

    /**
     * Updates entity schema sort order
     */
    async sortEntitySchema(requestParameters: SortEntitySchemaRequest, initOverrides?: RequestInit): Promise<InternalApiEntitySchema> {
        const response = await this.sortEntitySchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates entity schema
     */
    async updateEntitySchemaRaw(requestParameters: UpdateEntitySchemaRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntitySchema>> {
        if (requestParameters.internalApiEntitySchema === null || requestParameters.internalApiEntitySchema === undefined) {
            throw new runtime.RequiredError('internalApiEntitySchema','Required parameter requestParameters.internalApiEntitySchema was null or undefined when calling updateEntitySchema.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/schemas`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiEntitySchemaToJSON(requestParameters.internalApiEntitySchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntitySchemaFromJSON(jsonValue));
    }

    /**
     * Updates entity schema
     */
    async updateEntitySchema(requestParameters: UpdateEntitySchemaRequest, initOverrides?: RequestInit): Promise<InternalApiEntitySchema> {
        const response = await this.updateEntitySchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
